import React from "react";

const DeleteAccount: React.FC = () => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#1C3854",
        minHeight: "100vh",
        alignItems: "center",
        color: "#fff",
        fontFamily: "Poppins, sans-serif",
        padding: "2rem",
        paddingTop: "calc(64px + 2rem)",
      }}
    >
      <div
        style={{
          width: "80%",
          maxWidth: "800px",
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
        }}
      >
        <h1>How to delete your account from Zuz</h1>

        <p>
          At the moment, to request deletion of your account and personal data
          from Zuz, please send us an email at:
        </p>

        <p
          style={{
            backgroundColor: "rgba(255, 255, 255, 0.1)",
            padding: "1rem",
            borderRadius: "4px",
            fontFamily: "monospace",
          }}
        >
          support@zuz.giving
        </p>

        <p>Make sure to include the email address you used to register.</p>

        <p>We will delete your data within 7 days and confirm via email.</p>

        <h2>What data is deleted:</h2>
        <ul>
          <li>User profile</li>
          <li>Contact info</li>
          <li>App data</li>
        </ul>

        <h2>Retention</h2>
        <p>
          Some financial or legal data may be retained for up to 90 days as
          required by law.
        </p>
      </div>
    </div>
  );
};

export default DeleteAccount;
